import ReactMarkdown from "react-markdown";
import MessageShortcuts from "./MessageShortcuts";
import VoiceCallCard from "./VoiceCallCard";
import getInternalStyle from "../../../../../utils/Styles";
import localization from "../../../../../assets/localization";

export default function WelcomeMessage({
  style,
  assistantChatConfiguration,
  handleShortcutClick,
  assistantId,
  welcomeMessageTime,
  language = "it",
  isMobile = false,
}: any) {
  // Hotels without a configured welcome message still greet the guest —
  // essential now that variant B can auto-open the chat.
  const welcomeText =
    assistantChatConfiguration.welcomeMessage ||
    localization.get(language).welcome_message_default;
  const messages = welcomeText.split("$$$");
  return (
    <div
      style={{
        marginBottom: "10px",
        backgroundColor: getInternalStyle(assistantId, style).messages.bot
          .color,
      }}
      className="widget-chatbot-message"
    >
      {messages.length === 1 && (
        <>
          <ReactMarkdown>{welcomeText}</ReactMarkdown>
          {assistantChatConfiguration.shortcutButtons && (
            <MessageShortcuts
              assistantChatConfiguration={assistantChatConfiguration}
              style={style}
              handleShortcutClick={handleShortcutClick}
              assistantId={assistantId}
            />
          )}
        </>
      )}

      {messages.length === 2 && (
        <>
          <ReactMarkdown>{messages[0]}</ReactMarkdown>
          {assistantChatConfiguration.shortcutButtons && (
            <MessageShortcuts
              assistantChatConfiguration={assistantChatConfiguration}
              style={style}
              handleShortcutClick={handleShortcutClick}
              assistantId={assistantId}
            />
          )}
          <br></br>
          <ReactMarkdown>{messages[1]}</ReactMarkdown>
        </>
      )}

      <VoiceCallCard
        number={assistantChatConfiguration.voiceCallNumber}
        isMobile={isMobile}
        language={language}
      />

      <p className="message-time">{welcomeMessageTime}</p>
    </div>
  );
}
